import { Outlet } from "react-router-dom";

import { AppShell } from "./app-shell";

export function AppLayout() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
